import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';

export const TextareaHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const TextareaLabel = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const TextareaSymbolsCount = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const TextareaField = styled.textarea<{
  $height?: number;
  $minHeight?: number;
  $hasScrollbar?: boolean;
}>`
  ${({ $hasScrollbar }) => ($hasScrollbar ? '' : removeScrollbar())}

  position: relative;
  z-index: 2;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border: 0;
  outline: 0;
  font-size: 15px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.primary.labels};
  width: 100%;
  resize: none;
  border-radius: 7px;
  padding: 15px;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
    `}

  &::placeholder {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;
